import React from "react";

function Header({ user, setUser, small }) {
  if (small) {
    return (
      <div className="mobile-brand-card">
        <img
          src="/images/header-image.jpg"
          alt="UZHISHI"
          className="mobile-brand-avatar"
        />
        <div className="mobile-brand-copy">
          <span className="mobile-brand-title">佑知事</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="card header-card flex flex-col gap-2">
        <div className="flex items-center space-x-4">
          <img
            className="header-image items-center rounded-2xl border-3 border-[var(--primary)]"
            src="/images/header-image.jpg"
            width="60"
            height="50"
            alt="Logo"
          />

          <div className="flex items-center">
            <h1 className="text-xl header-name font-bold">佑知事</h1>
          </div>
        </div>

        <div>
          <p>Base in New Zealand, know the world.</p>
        </div>
      </div>
    </div>
  );
}

export default Header;
